import { useState } from 'react'
import { ReactComponent as MyBusinessIcon } from '../../icons/MyBusinessIcon.svg'
import { DreamStageModal, GetAIModal } from './AppModal'
import { MyBusinessSchema, BusinessFormData } from '../../data/types';
import { foodBusinessCategories } from '../../utils/enums';
import { useAllBusinesses, useUpdateBusinessDetails } from '../../hooks/businesshooks';
import { useCompleteSignIn } from '../../hooks/authhooks'
import BusinessCard from '../../components/Desktop/BusinessCard';
import { buildPrompt } from '../../utils/helpers';
const MyBusinessGrid = () => {
  const { user } = useCompleteSignIn();
  const username = user?.username || ''
  const [dreamModalIsOpen, setDreamModalIsOpen] = useState(false);
  const [getAIModalIsOpen, setGetAIModalIsOpen] = useState(false);
  const [showIntro, setShowIntro] = useState(true);
  const [editingBusiness, setEditingBusiness] = useState<MyBusinessSchema | null>(null);
  const { addBusinessDetails, removeBusinessDetails } = useUpdateBusinessDetails(username);
  const { businesses, isLoadingAllBusinesses } = useAllBusinesses(username);
  const [prompt, setPrompt] = useState<string>('');
  // const businesses: MyBusinessSchema[] = []
  // const isLoadingAllBusinesses = false
  
  const handleSubmitForm = async (data: BusinessFormData) => {
    const newBusinessData: MyBusinessSchema = {
      username: username,
      business_name: data.businessName || '',
      business_category: foodBusinessCategories[data.businessCategory as number].category,
      business_type: data.businessType || '',
      years_of_operation: data.yearsOfOperation || '',
      description: data.description || '',
      business_stage: data.businessStage || '',
      cooking_state: data.cookingState || '',
      cooking_county: data.cookingCounty || '',
      other_location: data.otherLocation || '',
      kitchen_timeframe: data.kitchenTimeframe || '',
      kitchen_budget: data.kitchenBudget || '',
      kitchen_frequency: data.kitchenFrequency || '',
      kitchen_size: data.kitchenSize || '',
      kitchen_equipment: data.kitchenEquipment || [],
      kitchen_features: data.kitchenFeatures || [],
      max_chefs: data.maxChefs || '',
      payment_frequency: data.paymentFrequency || '',
      kitchen_type: data.kitchenType || '',
    };

    const prompt = buildPrompt(newBusinessData)
    setPrompt(prompt)
    if (editingBusiness) {
      // Update existing business
      newBusinessData.id = editingBusiness.id;
      await addBusinessDetails(newBusinessData);
    } else {
      // Create new business
      await addBusinessDetails(newBusinessData);
    }


    
    // Close dream modal and open AI modal
    setDreamModalIsOpen(false);
    setGetAIModalIsOpen(true);
  }

  const handleEditBusiness = (business: MyBusinessSchema) => {
    setEditingBusiness(business);
    setDreamModalIsOpen(true);
    setShowIntro(false);
  };

  const handleDeleteBusiness = async (business: MyBusinessSchema) => {
    if (window.confirm('Are you sure you want to delete this business?') && business.id) {
      await removeBusinessDetails(business.id);
    }
  };

  // useEffect(() => {
  //   if (username) {
  //     reloadAllBusinesses()
  //   }
  // }, [username, reloadAllBusinesses])

  if (isLoadingAllBusinesses && businesses) {
    return (
      <div className="flex items-center justify-center min-h-[800px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primaryDark-400"></div>
      </div>
    );
  } else {
    return (
    <>
      {businesses && businesses.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
          {businesses.map((business, index) => (
            <BusinessCard 
              key={index} 
              business={business} 
              onEdit={handleEditBusiness}
              onDelete={handleDeleteBusiness}
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-start min-h-[800px] p-6">
          <div className="w-[80px] h-[80px] mb-6 bg-[#EFF8FA] rounded-full p-4">
            <MyBusinessIcon className="w-full h-full text-primaryDark-400" />
          </div>
          <h2 className="text-xl font-semibold mb-2">No Business Added Yet</h2>
          <p className="text-gray-600 text-center mb-6">
            It looks like you haven't set up your business yet.<br />
            Let's help you get started and connect you to the right resources!
          </p>
          <button 
            className="bg-primaryDark-100 border-0 hover:bg-primaryDark-300 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
            onClick={() => setDreamModalIsOpen(true)}
          >
            Add My Business
          </button>
        </div>
      )}

      <DreamStageModal 
        isOpen={dreamModalIsOpen} 
        showIntro={showIntro}
        setShowIntro={setShowIntro}
        closeAppModal={() => {
          setShowIntro(true)
          setDreamModalIsOpen(false)
          setEditingBusiness(null)
        }} 
        handleSubmitForm={handleSubmitForm}
        editingBusiness={editingBusiness}
      />
      <GetAIModal 
        isOpen={getAIModalIsOpen} 
        setIsOpen={setGetAIModalIsOpen}
        setDreamModalIsOpen={setDreamModalIsOpen}
        prompt={prompt}
      />
    </>
  )}
}

export default MyBusinessGrid

